import React, { Component } from "react";

import Paso1 from "./Paso1";


import Titulo from "../../../generico/TituloPagina";
import StepWizard from "react-step-wizard";

export default class Alias extends Component {

  constructor(props) {
    super(props);
    this.paso1 = React.createRef();


    this.state = {
      cuentaOrigen: { },
      cuentaDestino: { },
      importe: 0,
      nroOperacion: "",
      itemsConfirm: [],
      muestraPantallaEntrust:false,
    }
    
  }

  returnDataOTP(_codigo) {
    this.setState({
      codigo: _codigo

    });
  }
  

  resetState = () => {
    this.setState({
      cuentaOrigen: { },
      cuentaDestino: { },
      importe: 0,
      nroOperacion: "",
      itemsConfirm: [],
    })
  };

  componentDidMount() {
  }

  returnDataPaso1(
    _cuentaOrigen,
    _cuentaDestino,
    _importe,
    _itemsConfirm,
    _detalleCuenta,
    _cuentaOrigenSelected,
    _muestraPantallaEntrust
  ) {

    this.setState({
      cuentaOrigen: _cuentaOrigen,
      cuentaDestino: _cuentaDestino,
      importe: _importe,
      itemsConfirm: _itemsConfirm,
      detalleCuenta: _detalleCuenta,
      cuentaOrigenSelected: _cuentaOrigenSelected,
      muestraPantallaEntrust:_muestraPantallaEntrust
    });
  }

  

  initDataChildren() {
    //this.paso1.current.initData();
    //this.paso2.current.resetState();
  }

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Mis Alias" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card" >
                  <div className="card-body" style={{ zIndex: 0 }}>
                    <StepWizard transitions="none" isLazyMount={true}>
                      <Paso1
                        ref={this.paso1}
                        returnDataPaso1={this.returnDataPaso1.bind(this)}
                      />
                      
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
